module.exports = __webpack_public_path__ + "static/media/direct-instagram.87745241.svg";